<template>


    <div class="simulator-box" v-if="contribuicao">

        <div class="flex-row"  v-if="irpf_anuais.length === 0">
            <label v-if="usuario.pessoa.funcionario.funcionario_cargo_id === 1">
                Para preencher essa tela, é necessário que as configurações de <router-link :to="{name: 'configuracoes'}">IRPF anual</router-link> sejam feita antes.
            </label>
            <label v-else>
                Para preencher essa tela, é necessário que as configurações de IRPF anual sejam feita antes. Peça para que o administrador configure.
            </label>
        </div>
        <template v-else>
            <div class="card-panel" >

                <div class="flex-row">
                    <div class="col-xs-12 col-sm">
                        <h2 class="simulator-title loaded">Contribuição para previdência privada - PGBL</h2>
                    </div>
                    <div class="col-xs-12 col-sm" style="flex-grow: 0">
                        <div class="title-select">
                            <select @change="carregarPorAno(contribuicao.ano)" v-model="contribuicao.ano">
                                <option v-for="ano in anos" :key="`ano-${ano}`" :value="ano">
                                    {{ ano }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>


                <p class="grey-text mb-5">Comparativo entre o valor aportado atualmente na previdência e o cenário ideal de uma contribuição de 12% da renda tributável. Cálculo feito para demonstrar a redução da carga tributária quando a contribuição é total.</p>

                <div class="input-simulator-container">
                    <div class="flex-row between-xs middle-xs">

                        <div class="col-xs-12 col-md-4 col-md-offset-4 right-align">
                            <h4 class="subtitle">Cenário atual</h4>
                        </div>

                        <div class="col-xs-12 col-md-4 right-align">
                            <h4 class="subtitle">Cenário ideal</h4>
                        </div>

                        <label class="label col-xs-12 col-md-4">
                            <strong>RENDIMENTO TRIBUTÁVEL TOTAL</strong>
                        </label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.rendimento_tributavel_total" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            <strong>{{ contribuicao.rendimento_tributavel_total | dinheiro }}</strong>
                        </div>

                        <label class="label col-xs-12 col-md-4">PREVIDÊNCIA OFICIAL</label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.previdencia_oficial" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ previdencia_oficial_ideal | dinheiro }}
                        </div>


                        <label class="label col-xs-12 col-md-4">
                            PREVIDÊNCIA PRIVADA
                            <i class="material-icons" title="Contribuição máxima permitida (12% da renda bruta)">info</i>
                        </label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.previdencia_privada" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ previdencia_privada_ideal | dinheiro }}
                        </div>

                        <label class="label col-xs-12 col-md-4">DEPENDENTES</label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.dependentes" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.dependentes | dinheiro }}
                        </div>


                        <label class="label col-xs-12 col-md-4">
                            <span>DESPESAS COM INSTRUÇÃO</span>
                            <i class="material-icons" title="Valor máximo de dedução com instrução por dependente e/ou titular da declaração">info</i>
                        </label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.despesa_instrucao" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.despesa_instrucao | dinheiro }}
                        </div>


                        <label class="label col-xs-12 col-md-4">DESPESAS MÉDICAS</label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.despesa_medica" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.despesa_medica | dinheiro }}
                        </div>


                        <label class="label col-xs-12 col-md-4">PENSÃO ALIMENTÍCIA</label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.pensao_alimenticia" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.pensao_alimenticia | dinheiro }}
                        </div>


                        <label class="label col-xs-12 col-md-4">LIVRO CAIXA</label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.livro_caixa" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.livro_caixa | dinheiro }}
                        </div>

                        <div class="result col-xs-12 col-md-4">
                            <strong>TOTAL DE DESPESAS</strong>
                        </div>
                        <p class="col-xs-6 col-md-4 text-right">
                            <strong>{{ total_despesas_atual | dinheiro }}</strong>
                        </p>
                        <p class="col-xs-6 col-md-4 text-right">
                            <strong>{{ total_despesas_ideal | dinheiro }}</strong>
                        </p>
                    </div>
                </div>
            </div>
            <div class="card-panel">
                <div class="input-simulator-container">
                    <div class="flex-row middle-xs">
                        <label class="label col-xs-12 col-md-4">
                            <strong><span>BASE DE CÁLCULO</span></strong>
                        </label>
                        <p class="col-xs-6 col-md-4 text-right">
                            {{ base_calculo_atual | dinheiro }}
                        </p>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ base_calculo_ideal | dinheiro }}
                        </div>

                        <label class="label col-xs-12 col-md-4"><span>ALÍQUOTA IR</span></label>
                        <p class="col-xs-6 col-md-4 text-right">
                            <template v-if="irpf_ii_atual">
                            {{ irpf_ii_atual.aliquota }}%
                            </template>
                            <template v-else>-</template>
                        </p>
                        <p class="col-xs-6 col-md-4 text-right">
                            <template v-if="irpf_ii_ideal">
                            {{ irpf_ii_ideal.aliquota }}%
                            </template>
                            <template v-else>-</template>
                        </p>


                        <label class="label col-xs-12 col-md-4">
                            <span>PARCELA A DEDUZIR</span>
                        </label>
                        <p class="col-xs-6 col-md-4 text-right" >
                            <template v-if="irpf_ii_atual">
                                {{ irpf_ii_atual.valor_parcela_deducao | dinheiro }}
                            </template>
                            <template v-else>-</template>
                        </p>
                        <p class="col-xs-6 col-md-4 text-right">
                            <template v-if="irpf_ii_ideal">
                                {{ irpf_ii_ideal.valor_parcela_deducao | dinheiro  }}
                            </template>
                            <template v-else>-</template>
                        </p>


                        <label class="label col-xs-12 col-md-4">
                            IR DEVIDO II
                        </label>
                        <p class="col-xs-6 col-md-4 text-right" >
                            <template v-if="irpf_ii_atual">
                                {{ irpf_ii_devido_atual | dinheiro }}
                            </template>
                            <template v-else>-</template>
                        </p>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ irpf_ii_devido_ideal | dinheiro }}
                        </div>

                        <label class="label col-xs-12 col-md-4">
                            DOAÇÕES
                        </label>
                        <div class="col-xs-6 col-md-4 text-right">
                            <money type="text" class="form-control" v-model="contribuicao.doacoes" />
                        </div>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.doacoes | dinheiro }}
                        </div>

                        <template v-if="contribuicao.ano <= 2019">
                            <label class="label col-xs-12 col-md-4">
                                INSS DOMÉSTICA
                            </label>
                            <div class="col-xs-6 col-md-4 text-right">
                                <money type="text" class="form-control" v-model="contribuicao.inss_domestica" />
                            </div>
                            <div class="col-xs-6 col-md-4 text-right">
                                {{ contribuicao.inss_domestica | dinheiro }}
                            </div>
                        </template>

                        <label class="label col-xs-12 col-md-4">
                            IR DEVIDO
                        </label>
                        <p class="col-xs-6 col-md-4 text-right">
                            {{ Math.abs(irpf_devido_atual) | dinheiro }}
                        </p>
                        <div class="col-xs-6 col-md-4 text-right">
                            {{ Math.abs(irpf_devido_ideal) | dinheiro }}
                        </div>


                        <label class="label col-xs-12 col-md-4">
                            IMPOSTO RETIDO NO FONTE
                        </label>
                        <p class="col-xs-6 col-md-4 text-right">
                            <money v-model="contribuicao.imposto_retido_fonte" class="form-control" />
                        </p>
                        <p class="col-xs-6 col-md-4 text-right">
                            {{ contribuicao.imposto_retido_fonte | dinheiro }}
                        </p>


                        <div class="result col-xs-12 col-md-4">
                            <strong>SALDO DO IMPOSTO
                                <span class="text-primary" v-if="exibir_restituicao">{{ saldo_imposto_atual > 0 ? 'A PAGAR' : 'A RESTITUIR' }}</span>
                            </strong>
                        </div>


                        <p class="col-xs-6 col-md-4 text-right">
                            <strong>{{ Math.abs(saldo_imposto_atual) | dinheiro }}</strong>
                        </p>
                        <p class="col-xs-6 col-md-4 text-right">
                            <strong>{{ Math.abs(saldo_imposto_ideal) | dinheiro }}</strong>
                        </p>

                    </div>
                </div>
            </div>

            <div class="card-panel">
                <div class="flex-row middle-xs">
                    <div class="result col-xs-12 col-md-6">DIMINUIÇÃO DE IR</div>
                    <p class="col-xs-6 col-md-6 text-right">
                        <strong>{{ Math.abs(saldo_imposto_atual - saldo_imposto_ideal)  | dinheiro }}</strong>
                    </p>

                    <label class="label col-xs-12 col-md-9">VALOR JÁ CONTRIBUÍDO PARA A PREVIDÊNCIA PRIVADA NO ANO</label>
                    <p class="col-xs-6 col-md-3 text-right">
                        <money class="form-control" v-model="contribuicao.valor_contribuido_previdencia" />
                    </p>

                    <div class="result col-xs-12 col-md-9">APORTE A SER REALIZADO NA PREVIDÊNCIA PRIVADA</div>
                    <p class="col-xs-6 col-md-3 text-right">
                        <strong>{{ Math.max(0, previdencia_privada_ideal - contribuicao.valor_contribuido_previdencia) | dinheiro }}</strong>
                    </p>
                </div>
            </div>

            <div class="mt-4 text-right">
                <router-link class="btn btn-default" :to="{name: 'cliente_seguros_fonte_renda', params: $route.params}">
                    Concluir
                </router-link>
            </div>
        </template>



        <form class="modal" id="modal-form">
            <div class="modal-content">
                <h4>Selecione o Ano</h4>
                <div v-for="ano in anos"
                    @click.prevent="carregarIrpfPorAno(ano)"
                    class="btn btn-block mb-3"
                    :key="`ano-${ano}`"
                    :class="ano == contribuicao.ano ? 'btn-default' : 'grey-light'">
                    {{ ano }}
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import { api } from "@/helpers/api";
import { union } from "lodash"

import Auth from "@/store/auth";

export default {

    async created() {

        const {data: {result: {data: cliente}}} = await api.get(`cliente/${this.$route.params.id}`);

        const {data: config} = await api.get('configuracoes');

        this.cliente = cliente;

        const contribuicao = {
            ano: config.simular_ir_ano,
            rendimento_tributavel_total: 0,
            previdencia_oficial: 0,
            previdencia_privada: 0,
            pensao_alimenticia: 0,
            dependentes: 0,
            despesa_instrucao: 0,
            despesa_medica: 0,
            livro_caixa: 0,
            inss_domestica: 0,
            doacoes: 0,
            imposto_retido_fonte: 0,
            valor_contribuido_previdencia: 0,
            tipo: 'P',
            ...cliente.contribuicao_previdencia_privada
        };

        this.contribuicao = contribuicao;

        await this.carregarPorAno(contribuicao.ano);

        if (! contribuicao.ano && this.irpf_anuais.length) {
            contribuicao.ano = this.irpf_anuais[0].ano;
        }


        this.carregarAnos()

        this.carregando = false;
    },

    data() {

        return {
            carregando: true,
            irpf_anuais: [],
            previdencias_oficiais: [],
            anos: [],
            cliente: {},
            configuracao: {},
            contribuicao: null
        }
    },

    computed: {

        exibir_restituicao() {
            return this.contribuicao.previdencia_privada <= (this.contribuicao.rendimento_tributavel_total * 0.10)
        },

        usuario: () => Auth.state.user,


        teto_previdencia_oficial() {
            return this.previdencias_oficiais.find((item) => item.valor_maximo === null && item.valor_minimo);
        },

        teto_previdencia_oficial_valor() {

            const teto = this.teto_previdencia_oficial;

            if (! teto) return;

            return teto.valor_minimo * teto.aliquota * 0.01 * 12;
        },


        previdencia_privada_ideal() {
            return this.contribuicao.rendimento_tributavel_total * 0.12;
        },


        previdencia_oficial_ideal: {
            cache: false,
            get() {

                if (! this.previdencia_oficial) {
                    return 0;
                }
                else if (this.contribuicao.previdencia_oficial > 0) {
                    return this.contribuicao.previdencia_oficial;
                }
                else if (this.teto_previdencia_oficial === this.previdencia_oficial) {
                    return this.teto_previdencia_oficial_valor  ;
                }

                return this.contribuicao.rendimento_tributavel_total * this.previdencia_oficial.aliquota * 0.01;
            }
        },

        total_despesas_atual() {

            let total = 0;

            var keys = ['previdencia_oficial', 'pensao_alimenticia', 'dependentes', 'despesa_instrucao', 'despesa_medica', 'livro_caixa', 'previdencia_privada'];

            keys.forEach(key => {
                if (this.contribuicao[key]) {
                    total += this.contribuicao[key]
                }
            })

            return total;

        },

        total_despesas_ideal() {

            let total = this.previdencia_privada_ideal;

            var keys = ['previdencia_oficial', 'pensao_alimenticia', 'dependentes', 'despesa_instrucao', 'despesa_medica', 'livro_caixa'];

            keys.forEach(key => {
                if (this.contribuicao[key]) {
                    total += this.contribuicao[key]
                }
            })

            return total;
        },


        base_calculo_atual() {
            return Math.max(0, this.contribuicao.rendimento_tributavel_total - this.total_despesas_atual);
        },

        base_calculo_ideal() {
            return Math.max(0, this.contribuicao.rendimento_tributavel_total - this.total_despesas_ideal);
        },

        irpf_ii_atual() {
            return this.obterIrpf(this.base_calculo_atual);
        },

        irpf_ii_ideal() {

            return this.obterIrpf(this.base_calculo_ideal);
        },

        irpf_ii_devido_atual()
        {
            let {valor_parcela_deducao, aliquota} = {...this.irpf_ii_atual};

            return (this.base_calculo_atual * aliquota * 0.01) - valor_parcela_deducao;
        },

        irpf_ii_devido_ideal()
        {
            let {valor_parcela_deducao, aliquota} = {...this.irpf_ii_ideal};

            return (this.base_calculo_ideal * aliquota * 0.01) - valor_parcela_deducao;
        },

        irpf_devido_atual()
        {
            return (this.irpf_ii_devido_atual - this.contribuicao.doacoes - this.contribuicao.inss_domestica);
        },

        irpf_devido_ideal()
        {
            return this.irpf_ii_devido_ideal - this.contribuicao.doacoes - this.contribuicao.inss_domestica;
        },

        saldo_imposto_atual() {
            return this.irpf_devido_atual - this.contribuicao.imposto_retido_fonte;
        },

        saldo_imposto_ideal() {
            return this.irpf_devido_ideal - this.contribuicao.imposto_retido_fonte;
        },

        previdencia_oficial() {
            return this.obterPrevidenciaOficial(this.contribuicao.rendimento_tributavel_total / 12)
        },



    },

    methods: {

        async carregarAnos() {

            const {data: {result: {data: anos_irpf}}} = await api.get('irpf-anual/anos');

            const {data: {result: {data: anos_previdencia_oficial}}} = await api.get('previdencia-oficial/anos');

            this.anos = union(anos_irpf, anos_previdencia_oficial).filter(ano => {
                return anos_irpf.includes(ano) && anos_previdencia_oficial.includes(ano)
            })
        },

        async carregarIrpfPorAno(ano) {

            const {data: {result: {data: irpf_anuais}}} = await api.get('irpf-anual', {
                params: { ano: ano || undefined }
            });

            this.irpf_anuais  = irpf_anuais;

        },

        async carregarPrevidenciasOficiais(ano) {

            const {data: {result: {data: previdencias_oficiais}}} = await api.get('previdencia-oficial', {
                params: {ano: ano || undefined}
            });

            this.previdencias_oficiais = previdencias_oficiais;

        },


        async carregarPorAno(ano) {

            this.contribuicao.ano = ano;

            this.carregarIrpfPorAno(ano);
            this.carregarPrevidenciasOficiais(ano)
        },


        obterIrpf(base)
        {
            return this.irpf_anuais.find(item => {

                if (base <= item.valor_maximo && base >= item.valor_minimo) {
                    return true;
                }

                else if (item.valor_minimo === null && base <= item.valor_maximo) return true;

                return item.valor_maximo === null && base >= item.valor_minimo;

            })
        },

        obterPrevidenciaOficial(base)
        {
            return this.previdencias_oficiais.find(item => {

                if (item.valor_minimo === null && base < item.valor_maximo) return true;

                else if (item.valor_maximo === null && base > item.valor_minimo) return true;

                return base <= item.valor_maximo && base >= item.valor_minimo;

            })
        },



    },


    watch: {

        contribuicao: {
            deep: true,
            async handler(contribuicao) {

                this.irpf_ii_atual && await api.put('contribuicao-previdencia-privada', {
                    ...contribuicao,
                    cliente_id: this.$route.params.id,
                    irpf_aliquota: this.irpf_ii_atual.aliquota,
                    irpf_parcela_deduzir: this.irpf_ii_atual.valor_parcela_deducao,
                    tipo: 'P',
                    inss_domestica: contribuicao.ano > 2019 ? 0 : contribuicao.inss_domestica

                })

                this.carregando = false;
            }
        }


    }
}
</script>

<style lang="scss" scoped>
.text-right {
    text-align: right;
    .form-control {
        text-align: right;
    }
}
</style>

<style lang="scss" scoped>
    .label{
        // display: inline-flex;
        // align-items: center;
        // justify-content: space-between;
        font-size: 12px;
        // justify-content: space-between;

        .material-icons{
            font-size: 18px;
            margin-left: 5px;
        }

        a{
            font-weight: bold;
        }
    }

    .result{
        font-weight: bold;
        color: #222;
        font-size: 14px;
    }


     .subtitle{
        font-size: 20px;
        color: #a9a9a9;
        // font-weight: bold;
    }

    .simulator-title{
        margin-bottom: 0;
    }

    .description{
        color: #666;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/clientes/ContribuicaoParaPrevidenciaPGBL.vue